Utils = {};

Utils.isFunction = function (func) {
  let result = false;
  if (func) {
    result = toString.call(func) === '[object Function]' || toString.call(func) === '[object AsyncFunction]';
  }
  return result;
};

Utils.isPromise = function (promise) {
  let result = false;
  if (promise) {
    result = Utils.isFunction(promise.then);
  }
  return result;
};

Utils.isObject = function (obj) {
  let result = false;
  if (obj) {
    result = Object.getPrototypeOf(obj) === Object.getPrototypeOf({});
  }
  return result;
};

Utils.isNull = function (val) {
  let result = false;
  if (val === null) {
    result = true;
  }
  return result;
};

Utils.isUndefined = function (val) {
  let result = false;
  if (typeof val === 'undefined') {
    result = true;
  }
  return result;
};

Utils.isString = function (val) {
  let result = false;
  if (typeof val === 'string') {
    result = true;
  }
  return result;
};

Utils.isNumber = function (val) {
  let result = false;
  if (typeof val === 'number') {
    result = true;
  }
  return result;
};

Utils.isBoolean = function (val) {
  let result = false;
  if (typeof val === 'boolean') {
    result = true;
  }
  return result;
};

Utils.isArray = function (val) {
  let result = false;
  if (Array.isArray(val) === true) {
    result = true;
  }
  return result;
};

Utils.randomNumberBetween = function (min, max) {
  min = Math.ceil(min);
  max = Math.floor(max + 1);
  return Math.floor(Math.random() * (max - min)) + min;
};

Utils.playSpineAsync = async function (animName, spineAnim, hideWhenFinished = true) {
  let resolver = null;
  const promise = new Promise((resolve) => {
    resolver = resolve;
  });

  spineAnim.visible = true;
  spineAnim.spineObject.state.timeScale = 1;
  spineAnim.spineObject.state.clearListeners();

  spineAnim.play(animName, false, 0, () => {
    resolver();
  });

  await promise;

  if (hideWhenFinished) {
    spineAnim.visible = false;
  }
};

Utils.playMovieAsync = async function (movie, hideWhenFinished = true) {
  movie.visible = true;
  let resolver = null;
  const promise = new Promise((resolve) => {
    resolver = resolve;
  });
  movie.gotoAndPlay(0);
  movie.onComplete = () => {
    resolver();
  };
  await promise;
  if (hideWhenFinished) {
    movie.visible = false;
  }
};

Utils.tweenFromToAsync = async function (targets, fromVars, toVars, tweenInfo = null) {
  let resolver = null;
  const tweenPromise = new Promise((resolve) => {
    resolver = resolve;
  });

  const origOnComplete = toVars.onComplete;
  toVars.paused = true;
  toVars.onComplete = () => {
    if (origOnComplete) {
      origOnComplete();
    }
    resolver();
  };

  const tween = gsap.fromTo(targets, fromVars, toVars);
  tween.time(0).restart(true);

  if (tweenInfo) {
    tweenInfo.tween = tween;
    tweenInfo.resolver = resolver;
    tweenInfo.promise = tweenPromise;
  }

  return tweenPromise;
};

const textProto = PIXI.Text.prototype;
const originalDescriptor = Object.getOwnPropertyDescriptor(textProto, 'text');

Object.defineProperty(textProto, 'text', {
  get: originalDescriptor.get,
  set: function (input) {
    let value = input == null ? '' : String(input);

    const TOKEN = '\uFFF0';
    const protectedParts = [];

    if (this.style && this.style.breakWords) {
      value = value.replace(/(?:\d+(?:[.,]\d+)*(?:倍)?|\d+\s*~\s*\d+|倍回)/g, (match) => {
        protectedParts.push(match);
        return TOKEN;
      });
    }

    if (this.style && this.style.wordWrap && !this.style.breakWords) {
      const locale = gdk.getCurrentLanguage();

      if (locale === 'ja') {
        value = value.replace(/([\p{Script=Hiragana}\p{Script=Katakana}])/gu, '$1\u200A');
        value = value.replace(/\u200A([、。！？；（）「」『』・〜])/g, '$1');
      } else if (locale === 'zh_hant' || locale === 'zh_hans') {
        value = value.replace(/([\p{Script=Han}])/gu, '$1\u200A');
        value = value.replace(/\u200A([、。！？；：，（）“”‘’「」『』…·])/g, '$1');
      } else if (locale === 'th') {
        value = value.replace(/([\p{Script=Thai}])/gu, '$1\u200A');
        value = value.replace(/\u200A([ๆฯ“”‘’；（）…])/g, '$1');
      }
    }

    if (protectedParts.length > 0) {
      let i = 0;
      value = value.replace(new RegExp(TOKEN, 'g'), () => protectedParts[i++]);
    }

    originalDescriptor.set.call(this, value);
  },
});
